import { MotionConfig } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ChatWidget } from "./ChatWidget";
import { SmoothScroll } from "./motion";

export const Layout = ({ children }) => (
  <MotionConfig reducedMotion="user">
    <SmoothScroll>
      <div className="min-h-screen flex flex-col bg-[var(--bg-primary)]">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <ChatWidget />
      </div>
    </SmoothScroll>
  </MotionConfig>
);
